import React, { useState } from 'react';
import { 
  Container, 
  Typography, 
  Box, 
  Card, 
  CardContent, 
  CardMedia, 
  Grid, 
  ToggleButton, 
  ToggleButtonGroup,
  Chip,
  Stack
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

const Blog = () => {
  const navigate = useNavigate();
  const [selectedCategory, setSelectedCategory] = useState('Todos');
  
  const categories = [
    'Todos',
    'Derecho Corporativo',
    'Derecho Laboral',
    'Derecho Civil',
    'Derecho Fiscal'
  ];

  const blogPosts = [
    {
      id: 1,
      title: "Novedades en Derecho Laboral 2024",
      excerpt: "Análisis de las últimas modificaciones en la legislación laboral y su impacto en las empresas...",
      date: "2024-01-15",
      author: "Ana García",
      category: "Derecho Laboral",
      image: "https://images.unsplash.com/photo-1521791136064-7986c2920216?q=80&w=1000"
    },
    {
      id: 2,
      title: "Aspectos Clave del Derecho Fiscal",
      excerpt: "Guía completa sobre las obligaciones fiscales empresariales...",
      date: "2024-01-10",
      author: "Carlos Rodríguez",
      category: "Derecho Fiscal",
      image: "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?q=80&w=1000"
    },
    {
      id: 3,
      title: "Actualizaciones en Derecho Corporativo",
      excerpt: "Cambios importantes en la regulación empresarial...",
      date: "2024-01-05",
      author: "María López",
      category: "Derecho Corporativo",
      image: "https://images.unsplash.com/photo-1507537297725-24a1c029d3ca?q=80&w=1000"
    }
  ];

  const filteredPosts = selectedCategory === 'Todos' 
    ? blogPosts 
    : blogPosts.filter(post => post.category === selectedCategory);

  const handleCategoryChange = (event, newCategory) => {
    if (newCategory !== null) {
      setSelectedCategory(newCategory);
    }
  };

  const handlePostClick = (postId) => {
    console.log("Navegando a:", `/blogdetail/${postId}`);
    navigate(`/blogdetail/${postId}`);
  };

  return (
    <Box sx={{ pt: 8 }}>
      <Box sx={{ bgcolor: 'primary.main', color: 'white', py: 8 }}>
        <Container>
          <Typography variant="h2" component="h1" gutterBottom>
            Blog Legal
          </Typography>
          <Typography variant="h5">
            Noticias y actualizaciones del mundo legal
          </Typography>
        </Container>
      </Box>
      
      <Container sx={{ py: 4 }}>
        <ToggleButtonGroup
          value={selectedCategory}
          exclusive
          onChange={handleCategoryChange}
          sx={{ mb: 4, flexWrap: 'wrap' }}
        >
          {categories.map((category) => (
            <ToggleButton 
              key={category} 
              value={category}
              sx={{ m: 0.5 }}
            >
              {category}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>

        <Grid container spacing={4}>
          {filteredPosts.map((post) => (
            <Grid item key={post.id} xs={12} sm={6} md={4}>
              <Card 
                sx={{ 
                  height: '100%', 
                  display: 'flex', 
                  flexDirection: 'column',
                  transition: 'transform 0.2s',
                  '&:hover': {
                    transform: 'translateY(-8px)',
                    cursor: 'pointer'
                  }
                }}
                onClick={() => handlePostClick(post.id)}
              >
                <CardMedia
                  component="img"
                  height="200"
                  image={post.image}
                  alt={post.title}
                />
                <CardContent sx={{ flexGrow: 1 }}>
                  <Chip 
                    label={post.category}
                    color="primary"
                    size="small"
                    sx={{ mb: 1 }}
                  />
                  <Typography gutterBottom variant="h5" component="h2">
                    {post.title}
                  </Typography>
                  <Typography sx={{ mb: 2 }}>
                    {post.excerpt}
                  </Typography>
                  <Stack 
                    direction="row" 
                    justifyContent="space-between"
                    sx={{ color: 'text.secondary' }}
                  >
                    <Typography variant="body2">{post.author}</Typography>
                    <Typography variant="body2">
                      {new Date(post.date).toLocaleDateString('es-ES')}
                    </Typography>
                  </Stack>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default Blog;